import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWarning = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 44 44",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [/* @__PURE__ */ _jsxs("g", {
			filter: `url(#${__svgrId}-filter0_ii_2796_1775)`,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 44,
				height: 44,
				rx: 12,
				fill: "#FFC98E"
			}), /* @__PURE__ */ _jsxs("g", {
				filter: `url(#${__svgrId}-filter1_d_2796_1775)`,
				children: [
					/* @__PURE__ */ _jsxs("mask", {
						id: `${__svgrId}-path-2-outside-1_2796_1775`,
						maskUnits: "userSpaceOnUse",
						x: 14.6666,
						y: 5.74651,
						width: 14.4819,
						height: 29.9355,
						fill: "black",
						children: [/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							x: 14.6666,
							y: 5.74651,
							width: 14.4819,
							height: 29.9355
						}), /* @__PURE__ */ _jsx("path", { d: "M21.6896 23.2048C22.79 23.301 23.7601 22.487 23.8563 21.3867L24.6407 12.4209C24.737 11.3206 23.923 10.3505 22.8227 10.2542C21.7223 10.158 20.7522 10.9719 20.656 12.0723L19.8716 21.0381C19.7753 22.1384 20.5893 23.1085 21.6896 23.2048ZM20.9924 31.1743C22.0928 31.2706 23.0628 30.4566 23.1591 29.3562C23.2554 28.2559 22.4414 27.2858 21.341 27.1895C20.2406 27.0933 19.2706 27.9072 19.1743 29.0076C19.078 30.108 19.892 31.078 20.9924 31.1743Z" })]
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M21.6896 23.2048C22.79 23.301 23.7601 22.487 23.8563 21.3867L24.6407 12.4209C24.737 11.3206 23.923 10.3505 22.8227 10.2542C21.7223 10.158 20.7522 10.9719 20.656 12.0723L19.8716 21.0381C19.7753 22.1384 20.5893 23.1085 21.6896 23.2048ZM20.9924 31.1743C22.0928 31.2706 23.0628 30.4566 23.1591 29.3562C23.2554 28.2559 22.4414 27.2858 21.341 27.1895C20.2406 27.0933 19.2706 27.9072 19.1743 29.0076C19.078 30.108 19.892 31.078 20.9924 31.1743Z",
						fill: "#FFC98E"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23.8563 21.3867L27.343 21.6917V21.6917L23.8563 21.3867ZM20.656 12.0723L17.1693 11.7673V11.7673L20.656 12.0723ZM21.6896 23.2048L21.9947 19.7181C21.1694 19.6459 20.4419 20.2564 20.3697 21.0816L23.8563 21.3867L27.343 21.6917C27.0783 24.7177 24.4106 26.9562 21.3846 26.6914L21.6896 23.2048ZM23.8563 21.3867L20.3697 21.0816L21.1541 12.1159L24.6407 12.4209L28.1274 12.726L27.343 21.6917L23.8563 21.3867ZM24.6407 12.4209L21.1541 12.1159C21.0819 12.9412 21.6923 13.6687 22.5176 13.7409L22.8227 10.2542L23.1277 6.76754C26.1537 7.03228 28.3922 9.69996 28.1274 12.726L24.6407 12.4209ZM22.8227 10.2542L22.5176 13.7409C23.3429 13.8131 24.0704 13.2026 24.1426 12.3773L20.656 12.0723L17.1693 11.7673C17.434 8.74125 20.1017 6.5028 23.1277 6.76754L22.8227 10.2542ZM20.656 12.0723L24.1426 12.3773L23.3582 21.3431L19.8716 21.0381L16.3849 20.733L17.1693 11.7673L20.656 12.0723ZM19.8716 21.0381L23.3582 21.3431C23.4304 20.5178 22.82 19.7903 21.9947 19.7181L21.6896 23.2048L21.3846 26.6914C18.3586 26.4267 16.1201 23.759 16.3849 20.733L19.8716 21.0381ZM20.9924 31.1743L21.2974 27.6876C20.4722 27.6154 19.7446 28.2259 19.6724 29.0512L23.1591 29.3562L26.6458 29.6613C26.381 32.6873 23.7134 34.9257 20.6873 34.661L20.9924 31.1743ZM23.1591 29.3562L19.6724 29.0512C19.6002 29.8765 20.2107 30.604 21.036 30.6762L21.341 27.1895L21.6461 23.7029C24.6721 23.9676 26.9105 26.6353 26.6458 29.6613L23.1591 29.3562ZM21.341 27.1895L21.036 30.6762C21.8612 30.7484 22.5888 30.1379 22.661 29.3127L19.1743 29.0076L15.6876 28.7026C15.9524 25.6766 18.6201 23.4381 21.6461 23.7029L21.341 27.1895ZM19.1743 29.0076L22.661 29.3127C22.7332 28.4874 22.1227 27.7598 21.2974 27.6876L20.9924 31.1743L20.6873 34.661C17.6613 34.3963 15.4229 31.7286 15.6876 28.7026L19.1743 29.0076Z",
						fill: "white",
						mask: `url(#${__svgrId}-path-2-outside-1_2796_1775)`
					}),
					/* @__PURE__ */ _jsxs("mask", {
						id: `${__svgrId}-path-4-outside-2_2796_1775`,
						maskUnits: "userSpaceOnUse",
						x: 16.8333,
						y: 7.91321,
						width: 10.1485,
						height: 25.6021,
						fill: "black",
						children: [/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							x: 16.8333,
							y: 7.91321,
							width: 10.1485,
							height: 25.6021
						}), /* @__PURE__ */ _jsx("path", { d: "M21.6896 23.2048C22.79 23.301 23.7601 22.487 23.8563 21.3867L24.6407 12.4209C24.737 11.3206 23.923 10.3505 22.8227 10.2542C21.7223 10.158 20.7522 10.9719 20.656 12.0723L19.8716 21.0381C19.7753 22.1384 20.5893 23.1085 21.6896 23.2048ZM20.9924 31.1743C22.0928 31.2706 23.0628 30.4566 23.1591 29.3562C23.2554 28.2559 22.4414 27.2858 21.341 27.1895C20.2406 27.0933 19.2706 27.9072 19.1743 29.0076C19.078 30.108 19.892 31.078 20.9924 31.1743Z" })]
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M21.6896 23.2048C22.79 23.301 23.7601 22.487 23.8563 21.3867L24.6407 12.4209C24.737 11.3206 23.923 10.3505 22.8227 10.2542C21.7223 10.158 20.7522 10.9719 20.656 12.0723L19.8716 21.0381C19.7753 22.1384 20.5893 23.1085 21.6896 23.2048ZM20.9924 31.1743C22.0928 31.2706 23.0628 30.4566 23.1591 29.3562C23.2554 28.2559 22.4414 27.2858 21.341 27.1895C20.2406 27.0933 19.2706 27.9072 19.1743 29.0076C19.078 30.108 19.892 31.078 20.9924 31.1743Z",
						fill: "#FFC98E"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23.8563 21.3867L25.3506 21.5174V21.5174L23.8563 21.3867ZM20.656 12.0723L19.1617 11.9416V11.9416L20.656 12.0723ZM21.6896 23.2048L21.8204 21.7105C22.0955 21.7345 22.338 21.531 22.362 21.2559L23.8563 21.3867L25.3506 21.5174C25.1822 23.4431 23.4845 24.8675 21.5589 24.699L21.6896 23.2048ZM23.8563 21.3867L22.362 21.2559L23.1464 12.2902L24.6407 12.4209L26.135 12.5517L25.3506 21.5174L23.8563 21.3867ZM24.6407 12.4209L23.1464 12.2902C23.1705 12.0151 22.967 11.7726 22.6919 11.7485L22.8227 10.2542L22.9534 8.75993C24.879 8.9284 26.3035 10.626 26.135 12.5517L24.6407 12.4209ZM22.8227 10.2542L22.6919 11.7485C22.4168 11.7244 22.1743 11.9279 22.1503 12.203L20.656 12.0723L19.1617 11.9416C19.3301 10.0159 21.0278 8.59146 22.9534 8.75993L22.8227 10.2542ZM20.656 12.0723L22.1503 12.203L21.3658 21.1688L19.8716 21.0381L18.3773 20.9073L19.1617 11.9416L20.656 12.0723ZM19.8716 21.0381L21.3658 21.1688C21.3418 21.4439 21.5453 21.6864 21.8204 21.7105L21.6896 23.2048L21.5589 24.699C19.6333 24.5306 18.2088 22.833 18.3773 20.9073L19.8716 21.0381ZM20.9924 31.1743L21.1231 29.68C21.3982 29.7041 21.6407 29.5006 21.6648 29.2255L23.1591 29.3562L24.6534 29.487C24.4849 31.4126 22.7873 32.8371 20.8617 32.6686L20.9924 31.1743ZM23.1591 29.3562L21.6648 29.2255C21.6889 28.9504 21.4854 28.7079 21.2103 28.6838L21.341 27.1895L21.4717 25.6952C23.3974 25.8637 24.8219 27.5613 24.6534 29.487L23.1591 29.3562ZM21.341 27.1895L21.036 30.6762C21.8612 30.7484 22.5888 30.1379 22.661 29.3127L19.1743 29.0076L15.6876 28.7026C15.9524 25.6766 18.6201 23.4381 21.6461 23.7029L21.341 27.1895ZM19.1743 29.0076L22.661 29.3127C22.7332 28.4874 22.1227 27.7598 21.2974 27.6876L20.9924 31.1743L20.6873 34.661C17.6613 34.3963 15.4229 31.7286 15.6876 28.7026L19.1743 29.0076Z",
						fill: "#9A6528",
						mask: `url(#${__svgrId}-path-4-outside-2_2796_1775)`
					})
				]
			})]
		}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: `${__svgrId}-filter0_ii_2796_1775`,
			x: 0,
			y: 0,
			width: 44,
			height: 44,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect1_innerShadow_2796_1775"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_2796_1775"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -1 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_2796_1775",
					result: "effect2_innerShadow_2796_1775"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: `${__svgrId}-filter1_d_2796_1775`,
			x: 14.6665,
			y: 6.74609,
			width: 14.4819,
			height: 30.9355,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.603922 0 0 0 0 0.396078 0 0 0 0 0.156863 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_2796_1775"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_2796_1775",
					result: "shape"
				})
			]
		})] })]
	});
};
export default SvgIconWarning;
